import { NgModule } from '@angular/core';
import { TimerPipe } from '@shared/pipes/timer/timer.pipe';

@NgModule({
  declarations: [TimerPipe],
  exports: [TimerPipe],
  providers: [TimerPipe],
})
export class TimerPipeModule {}
